import React from 'react';
import { useDfcLocale } from '../../../../../context/DfcLocaleContext';
import useFitnessVillageCopy from '../../../../../hooks/useFitnessVillageCopy';
import { DFC_ARABIC_ENABLED } from '../../../../../Utils/dfcLocale';
import { DfcSurface } from '../../../../../Utils/dfcSurface';
import { LanguageButton } from './style';

interface LanguageSwitchProps {
  surface: DfcSurface;
  /** "full" — the other language spelled out (desktop); "short" — "ع" / "EN" (mobile). */
  variant: 'full' | 'short';
}

/**
 * English ⇄ Arabic for the village. It names the language it switches *to*, in that language,
 * so a visitor who reads only one of them can still find it. The whole page turns right-to-left
 * in place — no reload, nothing the visitor picked is lost.
 */
const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ surface, variant }) => {
  const { locale, setLocale } = useDfcLocale();
  const copy = useFitnessVillageCopy().header.languageSwitch;

  if (!DFC_ARABIC_ENABLED) return null;

  return (
    <LanguageButton
      surface={surface}
      onClick={() => setLocale(locale === 'ar' ? 'en' : 'ar')}
      aria-label={copy.aria}
      data-testid="language-switch"
    >
      <span lang={copy.lang} aria-hidden>
        {variant === 'full' ? copy.label : copy.short}
      </span>
    </LanguageButton>
  );
};

export default LanguageSwitch;
